import * as React from "react"
import { connect } from "react-redux"
import { RouteComponentProps } from "react-router"
import { AppState, AssignedClinic, WorkforceClinicPortal } from "../../AppState"
import { getUserNameForSelectedCompany, getLoggedInUserName, GetSelectedAssignedClinic, GetSelectedPortal } from "../../authentication/SelectedCompany/CompanySelectionDrivenSelectors"
import { Home } from "../../config/Routes"
import UserInfo, { UserInfoMode } from "../Administration/UserInfo"
import { AppPageWrapper } from "../NavMenu/AppPageWrapper"

interface MyInformationProps {
  LoginName: string
  AssignedClinic: AssignedClinic | null
  Portal?: WorkforceClinicPortal
}

export class MyInformation extends React.Component<MyInformationProps & RouteComponentProps> {
  handleClose = () => (this.props as RouteComponentProps).history?.push(Home)

  render() {
    const locationID = this.props.AssignedClinic?.LocationID
    const participationId = this.props.Portal?.ParticipationID || this.props.AssignedClinic?.ParticipationID

    return <AppPageWrapper showNav>
      <UserInfo mode={UserInfoMode.Personal} LoginName={this.props.LoginName} locationId={locationID} participationId={Number(participationId)} show onClose={() => this.handleClose()} />
    </AppPageWrapper>
  }
}

function mapStateToProps(state: AppState): MyInformationProps {
  return {
    LoginName: getLoggedInUserName(state),
    AssignedClinic: GetSelectedAssignedClinic(state),
    Portal: GetSelectedPortal(state)
  }
}

const ConnectedMyInformation = connect(mapStateToProps, null)(MyInformation)
export default ConnectedMyInformation
